<div class="modal-body">
  @if (description) {
    <p>{{description}}</p>
  }
  @if (validationItems.value.length > 0) {
    <rask-message-panel [numberOfItemsToDisplay]="2"
    [items]="validationItems"></rask-message-panel>
  }
  <form [formGroup]="form">

    <div class="row">
      @for (field of fieldData; track field) {
        <div [ngClass]="field.columnClass ? field.columnClass : 'col-md-12'">
          <ng-container
            [ngTemplateOutlet]="inputs"
            [ngTemplateOutletContext]="{field: field}">
          </ng-container>
        </div>
      }
    </div>
  </form>
</div>
<div class="modal-footer">
  @if (canDelete()) {
    <rask-button aid="buttonDelete" negative color="primary" (click)="delete()">{{deleteText}}
    </rask-button>
  }
  <rask-button aid="buttonSpara" color="primary" (click)="save()" [disabled]="!canSave()">{{saveText}}</rask-button>
  <rask-button aid="buttonAvbryt" color="secondary" (click)="dismiss()" ngbAutofocus>Avbryt</rask-button>
</div>
<ng-template let-field="field" #inputs>
  @if (field.type === 'number') {
    <rask-input-number
      [label]="field.label"
      [(ngModel)]="field.value"
      (change)="valueChanges()"
      [ngModelOptions]="{standalone: true}"
      [rule]="field.rules">
    </rask-input-number>
  }
  @if (field.type === 'button-group') {
    <rask-radiobutton-group
      [label]="field.label"
      [(ngModel)]="field.value"
      [buttons]="field.options"
      (change)="valueChanges()"
      [ngModelOptions]="{standalone: true}"
      [rule]="field.rules">
    </rask-radiobutton-group>
  }
  @if (field.type === 'simple-selector') {
    <rask-simple-selector
      [label]="field.label"
      [values]="field.values"
      [(ngModel)]="field.value"
      (change)="valueChanges()"
      [ngModelOptions]="{standalone: true}"
      [rule]="field.rules">
    </rask-simple-selector>
  }
  @if (field.type === 'json') {
    <pre style="max-height: 500px;">{{field.value | json | linebreak }}</pre>
  }
  @if (field.type === 'text') {
    <pre style="max-height: 500px;">{{field.value}}</pre>
  }
</ng-template>